import { OwAccordion } from "@components/shared/OwAccordion/OwAccordion";
import OwToggle from "@components/shared/OwToggle/OwToggle";
import { useAppContextNonNull } from "@contexts/AppContext";
import React from "react";
import catchwerksLogo from "@assets/images/catchwerks/catchwerks-lockup.svg";
import catchwerksLogoDark from "@assets/images/catchwerks/catchwerks-lockup-dark.svg";
import UIService from "@services/UIService";
import { OwIconTooltip } from "@components/shared/OwIconTooltip/OwIconTooltip";
import OwLabel from "@components/shared/OwLabel/OwLabel";

export const CatchwerksIntegration = () => {
    const { supplierModel } = useAppContextNonNull();

    return (
        <div>
            <OwAccordion
                hideChevron={true}
                titleClick={false}
                leftElem={
                    <div>
                        <img src={UIService.isMainViewLight() ? catchwerksLogo : catchwerksLogoDark} alt="Catchwerks" />
                    </div>
                }
                rightElem={
                    <div className={"ms-auto d-flex flex-column"}>
                        <div className="d-flex align-items-center gap-2">
                            <OwIconTooltip
                                iconClassName="text-muted fas fa-info-circle"
                                tooltipContent="catchwerks_tooltip"
                                translateContent={true}
                            />
                            <OwToggle
                                name="catchwerks"
                                active={!!supplierModel.Supplier_Integration.has_catchwerks}
                                fn={() => {}}
                                label={""}
                            />
                        </div>
                        {supplierModel.Supplier_Integration.has_catchwerks ? (
                            <div>
                                <div>
                                    <OwLabel
                                        title="sms_order_entry"
                                        leftIconClass={
                                            supplierModel.Supplier_Integration.sms_order_entry_enabled
                                                ? "fas fa-check-circle text-success"
                                                : "fas fa-times-circle text-danger"
                                        }
                                    />
                                </div>
                                <div>
                                    <OwLabel
                                        title="sms_reminders"
                                        leftIconClass={
                                            supplierModel.Supplier_Integration.sms_reminders_enabled
                                                ? "fas fa-check-circle text-success"
                                                : "fas fa-times-circle text-danger"
                                        }
                                    />
                                </div>
                            </div>
                        ) : null}
                    </div>
                }
            />
        </div>
    );
};
